import styled from 'styled-components';
import { bottomBarColor } from '../Page/styles';

const StyledFolderCreator = styled('div')`
	display: flex;
	align-items: center;
	padding: 15px;
	cursor: pointer;

	& > svg {
		flex: 0 0 auto;
		height: 20px;
		width: 20px;
		fill: ${bottomBarColor};
	}
`;

const FolderCreatorLabel = styled('div')`
	font-size: 13px;
	color: ${bottomBarColor};
	margin-left: 10px;
`;

export { StyledFolderCreator, FolderCreatorLabel };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/FolderCreatorFromSelection/styles.ts